import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AuthService } from 'app/services/auth.service';
import { DepertmentService } from 'app/services/models/depertment.service';
import { GlobalRolePersonService } from 'app/services/models/global-role-person.service';
import { GlobalRoleService } from 'app/services/models/global-role.service';
import { MissionService } from 'app/services/models/mission.service';
import { PersonService } from 'app/services/models/person.service';
import { ProjectService } from 'app/services/models/project.service';
import { Turkish } from 'flatpickr/dist/l10n/tr';
import { FlatpickrOptions } from 'ng2-flatpickr';
import { ToastrService } from 'ngx-toastr';
import { MissionDialogComponent } from '../mission-dialog/mission-dialog.component';
import { DepertmantDialogComponent } from '../depertmant-dialog/depertmant-dialog.component';

@Component({
  selector: 'app-update-work-dialog',
  templateUrl: './update-work-dialog.component.html',
  styleUrls: ['./update-work-dialog.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class UpdateWorkDialogComponent implements OnInit {
  @Input() data;
  person: any = {};
  personForm: FormGroup;
  birthDate: Date = null
  startDate: Date = null;
  leaveDate: Date = null;
  date = new Date();
  projects: [] = [];
  selectedProjects: any[] = [];
  roles: any[] = [];
  selectedRoles: any[] = [];

  depertmants: any[] = [];
  missions: any[] = [];

  constructor(
    private personService: PersonService,
    private fb: FormBuilder,
    private toastrService: ToastrService,
    private modalService: NgbModal,
    public activeModal: NgbActiveModal,
    private projectService: ProjectService,
    public authService: AuthService,
    private globalRoleService: GlobalRoleService,
    private globalPersonRoleService: GlobalRolePersonService,
    private missionService: MissionService,
    private depertmantSerivce: DepertmentService
  ) { }

  public dateTimeStartOptions: FlatpickrOptions = {
    altInput: true,
    enableTime: true,
    dateFormat: 'd.m.Y',
    altFormat: 'd.m.Y',
    locale: Turkish,
    defaultHour: 12,
  };

  public dateTimeEndOptions: FlatpickrOptions = {
    altInput: true,
    enableTime: true,
    dateFormat: 'd.m.Y',
    altFormat: 'd.m.Y',
    locale: Turkish,
    defaultHour: 12,
  };

  public dateTimeLeaveJobOptions: FlatpickrOptions = {
    altInput: true,
    enableTime: true,
    dateFormat: 'd.m.Y',
    altFormat: 'd.m.Y',
    locale: Turkish,
    defaultHour: 12,
  };

  async ngOnInit() {
    this.personForm = this.fb.group({
      name: [null, Validators.required],
      lastName: [null, Validators.required],
      mission: [null],
      phoneNumber: [null],
      mail: [null],
      address: [null],
      birthDay: [null],
      startDate: [null],
      workingStatus: [null],
      department: [null],
      emergencyContact: [null],
      tc: [null, [Validators.maxLength(11)]],
      wage: [null, Validators.min(0)],
      leaveJob: [null],
      registrationNumber: [null],
      depertmantId: [null],
      missionId: [null],
      projects: [[], this.authService.isEndpointStatus('PUT.Updateing.UpdatePersonProjects')
        ? [Validators.required]
        : []] // burada seçili projeler tutulacak
    });

    await this.getAllProjects('');
    await this.getAllDepertmant();
    await this.getAllMission();

    this.personForm.get('workingStatus')?.valueChanges.subscribe((status: boolean) => {
      const leaveJobControl = this.personForm.get('leaveJob');
      if (status === false) {
        leaveJobControl?.setValidators([Validators.required]);
      } else {
        leaveJobControl?.clearValidators();
      }
      leaveJobControl?.updateValueAndValidity();
    });

    this.personForm.get('projects')?.valueChanges.subscribe(selected => {
      this.updateSelectedProjects(selected);
    });

    await this.getByIdWorker(this.data);
    await this.getGlobalRoles(1);
  }

  async getGlobalRoles(id: number) {
    const data = await this.globalRoleService.getRoles(id);
    // Her role objesine "selected" ekle
    this.roles = data;
    await this.getByIdPersonRoles(this.person.id);
  }

  onRoleChange(roleId: number, event: Event) {
    const checked = (event.target as HTMLInputElement).checked;

    if (checked) {
      // Eğer daha önce eklenmemişse ekle
      if (!this.selectedRoles.includes(roleId)) {
        this.selectedRoles.push(roleId);
      }
    } else {
      // Checkbox işaret kaldırıldıysa listeden çıkar
      this.selectedRoles = this.selectedRoles.filter(r => r !== roleId);
    }

    console.log("Seçilen Roller:", this.selectedRoles);
  }


  async getByIdPersonRoles(id) {
    if (this.authService.isEndpointStatus('GET.Reading.GetByIdPersonRoles')) {
      const data = await this.globalPersonRoleService.getGlobalRolePerson(id);
      console.log(data);
      this.selectedRoles = data.map((x: any) => x.globalRoleId);
      console.log(this.selectedRoles);
    }
  }

  async createGlobalPeronRoles(ids: number[]) {
    console.log(this.selectedRoles);
    if (ids.length == 0) {
      this.toastrService.error('En az bir yetki seçiniz...');
      return;
    }
    const data = await this.globalPersonRoleService.createGlobalRolePerson(this.person.id, ids);
    if (data.status == true) {
      this.toastrService.success(data.message);
      this.closeModal();
    } else {
      this.toastrService.error(data.message);
    }
  }
  async removeAllRoles() {
    if (!this.selectedRoles || this.selectedRoles.length === 0) {
      this.toastrService.warning('Bu kullanıcıda seçili rol yok');
      return;
    }

    // Tüm rollerin ID’sini backend’e gönderip sil
    const data = await this.globalPersonRoleService.createGlobalRolePerson(this.person.id, []);
    if (data.status) {
      this.toastrService.success('Tüm roller kaldırıldı');
      this.selectedRoles = []; // frontend’de de temizle
    } else {
      this.toastrService.error(data.message);
    }
  }

  async onProjectSearch(searchTerm: any) {
    console.log(searchTerm.term);
    if (!searchTerm || searchTerm.length < 1) {
      this.projects = [];
      return;
    }
    await this.getAllProjects(searchTerm.term);
  }

  async getAllProjects(seach) {
    const data = await this.projectService.getAllProject(0, 50, seach, 1);
    console.log(data);
    this.projects = data.projects.map(p => ({
      ...p,
      isVisible: true // varsayılan görünür
    }));
  }

  async getByIdWorker(id) {
    console.log(id);
    const data = await this.personService.getByIdWorker(id);
    console.log(data);
    this.person = data;
    if (this.person != null) {
      this.personForm.patchValue({
        name: this.person.name,
        lastName: this.person.lastName,
        mission: this.person.mission,
        phoneNumber: this.person.phoneNumber,
        mail: this.person.mail,
        address: this.person.address,
        birthDay: this.person.personalAdditionalInfarmation?.birthDay,
        startDate: this.person.personalAdditionalInfarmation?.startDate,
        workingStatus: this.person.personalAdditionalInfarmation?.workingStatus,
        department: this.person.personalAdditionalInfarmation?.department,
        emergencyContact: this.person.personalAdditionalInfarmation?.emergencyContact,
        tc: this.person.personalAdditionalInfarmation?.tc,
        wage: this.person.personalAdditionalInfarmation?.wage,
        leaveJob: this.person.personalAdditionalInfarmation?.workingStatus == true ? null : this.person.personalAdditionalInfarmation?.leaveJob,
        registrationNumber: this.person.personalAdditionalInfarmation.registrationNumber,
        projects: this.person.personProjects,
        missionId:this.person.personalAdditionalInfarmation.missionId,
        depertmantId:this.person.personalAdditionalInfarmation.depertmantId
      });

      this.birthDate = new Date(this.personForm.value.birthDay);
      this.startDate = new Date(this.personForm.value.startDate);
      this.leaveDate = this.person.personalAdditionalInfarmation?.workingStatus == true ? null : (this.person.personalAdditionalInfarmation.leaveJob ? new Date(this.personForm.value.leaveJob) : new Date());
    }
    this.selectedProjects = (this.person?.personProjects || [])?.map(p => ({
      id: p.projectId,
      name: p.name,
      isVisible: p.isVisible
    }));
    this.updateWorkingDays(this.person?.personalAdditionalInfarmation?.workingDays ?? []);
  }

  days = [
    { name: 'Monday', label: 'Pazartesi', selected: false, startTime: { hour: 9, minute: 0 }, endTime: { hour: 18, minute: 0 } },
    { name: 'Tuesday', label: 'Salı', selected: false, startTime: { hour: 9, minute: 0 }, endTime: { hour: 18, minute: 0 } },
    { name: 'Wednesday', label: 'Çarşamba', selected: false, startTime: { hour: 9, minute: 0 }, endTime: { hour: 18, minute: 0 } },
    { name: 'Thursday', label: 'Perşembe', selected: false, startTime: { hour: 9, minute: 0 }, endTime: { hour: 18, minute: 0 } },
    { name: 'Friday', label: 'Cuma', selected: false, startTime: { hour: 9, minute: 0 }, endTime: { hour: 18, minute: 0 } },
    { name: 'Saturday', label: 'Cumartesi', selected: false, startTime: { hour: 10, minute: 0 }, endTime: { hour: 16, minute: 0 } },
    { name: 'Sunday', label: 'Pazar', selected: false, startTime: { hour: 10, minute: 0 }, endTime: { hour: 16, minute: 0 } },
  ];

  updateWorkingDays(workingDays: any[]): void {
    // Güncel çalışma günlerini "days" array'ine işliyoruz
    this.days.forEach(day => {
      const workingDay = workingDays?.find(wd => wd.day === day.name);
      if (workingDay) {
        day.selected = true;
        const [startHour, startMinute] = workingDay.start.split(':').map(Number);
        const [endHour, endMinute] = workingDay.end.split(':').map(Number);
        day.startTime = { hour: startHour, minute: startMinute };
        day.endTime = { hour: endHour, minute: endMinute };
      }
    });
  }

  async getAllMission() {
    const data = await this.missionService.getAllMission();
    this.missions = data;
  }

  async getAllDepertmant() {
    const data = await this.depertmantSerivce.getAllDepertmant();
    this.depertmants = data;
  }

  closeModal() {
    this.activeModal.close();
  }

  async onSumbit() {
    console.log(this.personForm.value);

    const selectedDays = this.days
      .filter((day) => day.selected)
      .map((day) => ({
        Day: day.name,
        start: `${day.startTime.hour.toString().padStart(2, '0')}:${day.startTime.minute.toString().padStart(2, '0')}`,
        end: `${day.endTime.hour.toString().padStart(2, '0')}:${day.endTime.minute.toString().padStart(2, '0')}`,
      }));
    console.log(selectedDays);
    const formData = this.personForm.value;
    let start = new Date(formData.startDate[0]);
    start.setHours(start.getHours() + 3);
    const birth = new Date(formData.birthDay[0]);
    birth.setHours(birth.getHours() + 3);

    const projectAssignmentDtos = this.selectedProjects.map(p => ({
      projectId: p.id,
      name: p.name,
      isVisible: p.isVisible
    }));

    const workerData = {
      id: this.person.id, // Eğer formda id yoksa varsayılan olarak 0 kullanılır
      name: formData.name,
      lastName: formData.lastName,
      mission: formData.mission,
      phoneNumber: formData.phoneNumber,
      mail: formData.mail,
      address: formData.address,
      companyId: 1, // Eğer formda companyId yoksa varsayılan olarak 0 kullanılır
      updatePersonalAdditionalInfarmation: {
        id: this.person.personalAdditionalInfarmation?.id ?? 0, // Varsayılan id değeri
        tc: formData.tc,
        birthDay: birth, // Tarih array içinden çekilir
        startDate: start, // Tarih array içinden çekilir
        department: formData.department,
        workingStatus: formData.workingStatus,
        wage: formData.wage,
        emergencyContact: formData.emergencyContact,
        personId: this.person.id, // Varsayılan personId değeri,
        leaveJob: formData.wokingStatus ? null : (formData.leaveJob != null ? new Date(formData.leaveJob[0]) : null),
        workingDays: selectedDays,
        registrationNumber: formData.registrationNumber,
        depertmantId:formData.depertmantId,
        missionId:formData.missionId
      },
      projectAssignmentDtos: projectAssignmentDtos
    };
    console.log(workerData);
    const response = await this.personService.updateWorker(workerData);
    console.log(response);
    if (response.status == true) {
      this.personService.sendEvent(true);
      this.toastrService.success(response.message);
      this.closeModal();
    } else {
      this.toastrService.error(response.message);
    }
  }

  applyToAll() {
    const firstDay = this.days[0];
    if (!firstDay.selected) {
      return;
    }
    const startTime = firstDay.startTime;
    const endTime = firstDay.endTime;
    this.days.forEach((day, index) => {
      if (index !== 0 && day.selected) {
        day.startTime = { ...startTime };
        day.endTime = { ...endTime };
      }
    });
  }

  toggleProjectVisibility(project: any, isVisible: boolean) {
    project.isVisible = isVisible;

    const currentProjects = this.personForm.get('projects')?.value || [];
    const index = currentProjects.findIndex(p => p.id === project.id);
    if (index > -1) {
      currentProjects[index] = { ...project };
      this.personForm.get('projects')?.setValue(currentProjects, { emitEvent: false });
    }
  }

  updateSelectedProjects(selected: any[]) {
    this.selectedProjects = (selected || []).map(p => {
      const existing = this.selectedProjects.find(sp => sp.id === p.id);
      return { ...p, isVisible: existing ? existing.isVisible : true };
    });
    console.log('Seçilen projeler:', this.selectedProjects);
  }

  onProjectChange(selected: any[]) {
    // Seçilen projeleri güncelle
    this.selectedProjects = selected.map(p => {
      const existing = this.selectedProjects.find(sp => sp.id === p.id);
      return { ...p, isVisible: existing ? existing.isVisible : true };
    });

    console.log('Seçilen projeler:', this.selectedProjects);
  }


  async showCreateMissionDialog() {
    const modal = this.modalService.open(MissionDialogComponent, {
      size: 'sm',
      centered: true,
      windowClass: 'modal modal-success'
    });
    modal.result.then(async (result) => {
      if (result == true) {
        await this.getAllMission();
      }
    }, (reason) => {
      console.log('Modal kapatıldı:', reason);
    });
  }

  async showCreateDepartmanDialog() {
    const modal = this.modalService.open(DepertmantDialogComponent, {
      size: 'sm',
      centered: true,
      windowClass: 'modal modal-success'
    });
    modal.result.then(async (result) => {
      if (result == true) {
        await this.getAllDepertmant();
      }
    }, (reason) => {
      console.log('Modal kapatıldı:', reason);
    });
  }
}
